import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ActionCreators as UndoActionCreators } from 'redux-undo';
import AriaModal from 'react-aria-modal';

import { clearNodes } from '~app/actions/nodeList';
import MenuItem from './MenuItem';
import OkCancelPopup from '~app/components/OkCancelPopup';
import FileMenu from './FileMenu';
import ZoomTool from '~app/components/ZoomTool/ZoomTool';
import { saveProject, loadProject } from '~app/actions/drive';
import { saveToLocal, loadFromLocal } from '~app/actions/local';
import { exportPowerPoint } from '~app/actions/pptxgen';
import GoogleDriveFileSelect from './GoogleDriveFileSelect';
import GoogleDriveFileSave from './GoogleDriveFileSave';
import { signIn, listFiles } from '~app/actions/drive';
import { getBrowser } from '~app/utils/getBrowser';
import { withT, withResources } from "~app/BundleProvider";

import Logging from '~app/core/logging';
const log = Logging.getLogger('app.components.menubar');

class MenuBar extends Component {
  static propTypes = {
    saveToLocal: PropTypes.func.isRequired,
    loadFromLocal: PropTypes.func.isRequired,
    exportPowerPoint: PropTypes.func.isRequired,
  }

  state = {
    showPopup: false,
    showPowerPointPopup: false,
    showHamburger: false,
    showSaveDialogType: '',
    showDriveSelect: false,
    driveFileList: null,
  }

  showPopup = () => {
    this.setState({showPopup: true});
  }

  hidePopup = () => {
    this.setState({showPopup: false});
  }

  hidePowerPointPopup = () => this.setState({ showPowerPointPopup: false });

  showDriveSelect = () => {
    this.setState({showDriveSelect: true});
  }

  hideDriveSelect = () => {
    this.setState({showDriveSelect: false, driveFileList: null});
  }

  hideFileSaveDialog = () =>
    this.setState({showSaveDialogType: ''});

  driveFileSelected = (fileId) => {
    log.debug(fileId);
    this.hideDriveSelect();
    // Dispatch file loading
    this.props.openFromGoogle(fileId);
  }

  handleFileSave = (fileName) => {
    const { showSaveDialogType } = this.state;
    const { saveToGoogle, saveToLocal } = this.props;

    this.hideFileSaveDialog();

    if (showSaveDialogType === 'drive') saveToGoogle(fileName);

    else if (showSaveDialogType === 'local') saveToLocal(fileName);
  }


  clearAllNodes = () => {
    this.props.clearNodes();
    this.props.clearHistory();
    this.hidePopup();
  }

  handleFileMenuSelect = (info) => {
    switch (info) {
      case 'open-from-google':
        // Dispatch busy?

        // Sign-in
        this.props.googleSignIn()
        .then((res)=>{
          // Get file list
          return this.props.listGoogleDriveFiles();
        })
        .then((files) => {
          this.setState({driveFileList:files});
          this.showDriveSelect();
        })
        .catch((e) => {
          if(e.error !=='popup_closed_by_user')
            log.error(e.error);
        });
        break;
      case 'open-from-pc':
        // activate the hidden file input
        this.fileUploader.click();
        break;
      case 'save-to-google':
      // Sign-in
      this.props.googleSignIn()
      .then((res)=>{
        this.setState({ showSaveDialogType: 'drive' });
      })
      .catch((e) => {
        if(e.error !=='popup_closed_by_user')
          log.error(e.error);
      });
        break;
      case 'save-to-pc':
        this.setState({ showSaveDialogType: "local" });
        break;
      case 'export-power-point':
          this.confirmPowerPointExport();
        break;
      default:
        break;
    }
  }

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    this.props.loadFromLocal(file);
  }

  openBurgerMenu = () => this.setState({showHamburger: true});
  closeBurgerMenu = () => this.setState({showHamburger: false});

  // warn users of browsers other than Chrome or Firefox that flowchart image
  // will not be included before exporting
  confirmPowerPointExport = () => {
    const {r} = this.props;
    const browser = getBrowser();
    if (browser !== "Chrome" && browser !== "Firefox") {
      this.setState({ showPowerPointPopup: true });
    }
    else {  
      this.hidePowerPointPopup();
      const bannerURL = r('banner.png');
      this.props.exportPowerPoint(bannerURL);
    }
  }

  // if user chooses to export power point from confirmation popup
  exportPowerPoint = () => {
    const {r} = this.props;
    this.hidePowerPointPopup();
    const bannerURL = r('banner.png');
    this.props.exportPowerPoint(bannerURL);
  }

  render() {
    const { t } = this.props;
    return (
      <div>

        {/* this input is hidden from the user but allows the user to load a
        project from pc using file menu */}
        <input
          type="file"
          id="file"
          value=""
          ref={el => this.fileUploader = el}
          style={{display: 'none'}}
          onChange={this.handleFileUpload}
          aria-label={t("file-upload")}
          aria-hidden
        />

        {this.state.showHamburger ?

          <div>
            <FileMenu
              closeMenu={this.closeBurgerMenu}
              handleSelect={this.handleFileMenuSelect}
              aria-owns="wrapper-menu"
            />
          </div>

          :

          <div className="MenuBar">

            <ZoomTool />

            <MenuItem
              title={t("undo")}
              styleName="undo"
              ariaLabel={t("undo")}
              tabIndex="0"
              onClick={this.props.onUndo}
              disabled={this.props.nodeList.past.length === 0}
            />

            <div ref="target">
              <MenuItem
                title={t("delete-all")}
                styleName="trash"
                ariaLabel={t("delete-all")}
                tabIndex="0"
                onClick={this.showPopup}
                disabled={this.props.nodeList.present.nodes.length === 0}
              />
            </div>

            <MenuItem
              styleName="hamburger"
              ariaLabel={t("open-file-menu")}
              tabIndex="0"
              onClick={this.openBurgerMenu}
            />
          </div>
        }

        <AriaModal
          mounted={this.state.showPopup}
          onExit={this.hidePopup}
          titleText={t("delete-all-work")}
          underlayColor="rgba(0,0,0,0)"
          // underlayClass="PopupBackdrop"
          >
          <OkCancelPopup
            onOk={this.clearAllNodes}
            onCancel={this.hidePopup}
            mainText={t("delete-all-work-question")}
            subText={t("can't-undone")}
            okText={t("delete-all")}
            cancelText={t("cancel")}
            messageType="warning"
          />
        </AriaModal>

        <AriaModal
          mounted={this.state.showPowerPointPopup}
          onExit={this.hidePowerPointPopup}
          titleText={t("export-powerpoint")}
          // underlayClass="PopupBackdrop"
          underlayColor="rgba(0,0,0,0)">
          <OkCancelPopup
            onOk={this.exportPowerPoint}
            onCancel={this.hidePowerPointPopup}
            mainText={t("export-without-flowchart")}
            subText={t("export-with-flowchart")}
            warningText={t("don't-forget-save")}
            okText={t("export")}
            cancelText={t("cancel")}
            messageType="warning"
          />
        </AriaModal>

        <AriaModal
          mounted={this.state.showDriveSelect}
          onExit={this.hidePDriveSelect}
          titleText={t("open-google")}
          // underlayClass="PopupBackdrop"
          underlayColor="rgba(0,0,0,0)">
          <GoogleDriveFileSelect
            fileList={this.state.driveFileList}
            handleSelect={this.driveFileSelected}
            onCancel={this.hideDriveSelect}
          />
        </AriaModal>

        <AriaModal
          mounted={!!this.state.showSaveDialogType}
          onExit={this.hideFileSaveDialog}
          titleText={t("save-google")}
          // underlayClass="PopupBackdrop"
          underlayColor="rgba(0,0,0,0)">
          <GoogleDriveFileSave
            type={this.state.showSaveDialogType}
            handleSave={this.handleFileSave}
            onCancel={this.hideFileSaveDialog}
          />
        </AriaModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  nodeList: state.nodeList,
  fullstate: state,
});

const mapDispatchToProps = (dispatch) => {
  return {
    clearNodes: ()=> dispatch(clearNodes()),
    clearHistory: () => dispatch(UndoActionCreators.clearHistory()),
    onUndo: () => dispatch(UndoActionCreators.undo()),
    openFromGoogle: (fileId) => dispatch(loadProject(fileId)),
    saveToGoogle: (fileName) => dispatch(saveProject(fileName)),
    saveToLocal: (fileName) => dispatch(saveToLocal(fileName)),
    loadFromLocal: (file) => dispatch(loadFromLocal(file)),
    googleSignIn: () => dispatch(signIn()),
    listGoogleDriveFiles: () => dispatch(listFiles()),
    exportPowerPoint: (bannerURL) => dispatch(exportPowerPoint(bannerURL)),
  };
};

export default withResources(withT(connect(mapStateToProps, mapDispatchToProps)(MenuBar)));



// WEBPACK FOOTER //
// ./src/pages/Main/menu/MenuBar.js